import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "../layout/container/SimpleBox";

const Club = ({ club, forceAuxSpace = false, showScore = false, highlight = false }) => {

    const theme = useTheme();
    const hasAux = Boolean(club) && Boolean(club.aux);
    const lenAux = hasAux ? club.aux.length : 0;
    const auxElement = <Typography color={theme.palette.davysGray.main}>{hasAux ? club.aux.toUpperCase() : "\u00A0"}</Typography>
    const logoSrc = Boolean(club) && Boolean(club.logoUrl) ? club.logoUrl : `${process.env.PUBLIC_URL}/img/club.png`;
    const clubName = Boolean(club) ? club.name.toUpperCase() : "Vários Jogos";
    const logoHeight = {xs: "40px", sm: "55px", md: "70px"};

    return (
        <SimpleBox flexDirection="column" justifyContent="center">
            <Box width="60px" display="flex" height={logoHeight} justifyContent="center" alignItems="center">
                <Box component="img" src={logoSrc} alt={clubName} maxWidth="100%" maxHeight={logoHeight} />
            </Box>
            <SimpleBox mt={2} justifyContent="center" gap={2}>
                <Typography fontWeight="bold">{clubName}</Typography>
                { lenAux === 1 ? auxElement : null }
            </SimpleBox>
            { forceAuxSpace || lenAux > 1 ? auxElement : null }
            {
                showScore && Boolean(club) ? (
                    <Typography
                        fontSize={{xs: "1.1rem", sm: "1.3rem", md: "1.6rem" }}
                        fontWeight="bold"
                        color={highlight ? theme.palette.primary.dark : theme.palette.davysGray.main}
                    >
                        {club.score}
                    </Typography>
                ) : null
            }
        </SimpleBox>
    );
}

export default Club;
